import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedThemeName: null,
  themes: [
    {
      name: 'default',
      label: 'Default',
      mode: 'light',

      'primary-text-color': '#252423',
      'secondary-text-color': '#484644',

      surface: '#ffffff',
      'surface-border': '#fdfdfd',
      surface2: '#f3f2f1',
      'surface2-border': '#f0efee',
      'side-item-active': '#edebe9',
      'side-item-hover': '#f3f2f1',
      'conversation-sent-bubble': '#1F7DB8',
      'conversation-received-bubble': '#ffffff',
      'conversation-border-bubble': '#c7c7c7',
      'input-bg': '#ffffff',
      'input-bg2': '#f3f2f1',
      'input-border': '#ffffff',
      'primary-button-hover': '#045BB4',
      'primary-button-font-color': '#ffffff',
      primary: '#0451a1',
      secondary: '#f47920',
      accent: '#f47920',
      info: '#77A8DA',
      success: '#4EA96D',
      error: '#F44336',
      warning: '#FCCC4A'
    },
    {
      name: 'dark',
      label: 'Dark',
      mode: 'dark',

      'primary-text-color': '#f3f2f0',
      'secondary-text-color': '#bebbb8',

      surface: '#2d2c2c',
      'surface-border': '#2a2929',
      surface2: '#201f1f',
      'surface2-border': '#1e1d1c',
      'side-item-active': '#484644',
      'side-item-hover': '#3b3a39',
      'conversation-sent-bubble': '#1F7DB8',
      'conversation-received-bubble': '#2d2c2c',
      'conversation-border-bubble': '#201f1f',
      'input-bg': '#2d2c2c',
      'input-bg2': '#2d2c2c',
      'input-border': '#2d2c2c',
      'primary-button-hover': '#2288C9',
      'primary-button-font-color': '#ffffff',
      primary: '#1f7db8',
      secondary: '#f47920',
      accent: '#f47920',
      info: '#77A8DA',
      success: '#4EA96D',
      error: '#F44336',
      warning: '#FCCC4A'
    },
    {
      name: 'contrast',
      label: 'High Contrast',
      mode: 'dark',

      'primary-text-color': '#f3f2f0',
      'secondary-text-color': '#bebbb8',

      surface: '#000000',
      'surface-border': '#2a2929',
      surface2: '#000000',
      'surface2-border': '#1e1d1c',
      'side-item-active': '#1aebff',
      'side-item-hover': '#ffff01',
      'conversation-sent-bubble': '#19192a',
      'conversation-received-bubble': '#000000',
      'conversation-border-bubble': '#ffffff',
      'input-bg': '#000000',
      'input-bg2': '#000000',
      'input-border': '#ffffff',
      'primary-button-hover': '#ffff01',
      'primary-button-font-color': '#000000',
      primary: '#ffffff',
      secondary: '#909892',
      accent: '#FFC107',
      info: '#77A8DA',
      success: '#4EA96D',
      error: '#F44336',
      warning: '#FCCC4A'
    }
  ]
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
